
<header id="page-header" class="flex justify-between gap-6 max-[768px]:gap-12 max-h-[50rem] text-[#334155]">
  <div id="header-info-container" class="flex flex-col justify-between gap-8">
    <div class="flex flex-col">
      <div id="header-breadcrumbs" class="flex gap-2 items-center mb-10">
        <span class="not-clickable">Article</span>
        <span class="separator">></span>
        <a 
          :href="`${allArticlesPath}?category=${this.categoryKey}`"
          :disabled="!this.categoryKey"
          :class="[
            { 'clickable': this.categoryKey }
          ]"
        >{{ pageCategory }}</a>
      </div>
      <h1 class="text-[2.5rem] leading-[3rem] mb-12 max-[768px]:mb-8">{{ title }}</h1>
      <div class="flex flex-col text-[0.875rem]">
        <span class="leading-[1.25rem]">By {{ authorName || 'unknown author' }}</span>
        <span class="leading-[1.6875rem]">{{ parsedCreatedAt }} • {{ readTime.toFixed(0) }} min read</span>
      </div>
    </div>
    <ShareLinks :page-path="articlePath" />
  </div>
  <div id="header-img-container" class="flex rounded-lg">
    <img 
      :src="imageUrl || imagePlaceholder || '../../../images/placeholder.webp'"
      alt="Article header image"
      class="aspect-auto object-cover"
    />
  </div>
</header>
